module.exports = __webpack_public_path__ + "img/contact.ae73ea4c.svg";